export const GET_DOCUMENTS_ADVISERS_ABORTED = 'GET_DOCUMENTS_ADVISERS_ABORTED';
export const GET_DOCUMENTS_ADVISERS_REQUESTED =
  'GET_DOCUMENTS_ADVISERS_REQUESTED';
export const GET_DOCUMENTS_ADVISERS_COMPLETED =
  'GET_DOCUMENTS_ADVISERS_COMPLETED';
export const GET_DOCUMENTS_ADVISERS_FAILED = 'GET_DOCUMENTS_ADVISERS_FAILED';

export const RESET_DOCUMENTS_ADVISERS_REQUESTED =
  'RESET_DOCUMENTS_ADVISERS_REQUESTED';
export const RESET_DOCUMENTS_ADVISERS_COMPLETED =
  'RESET_DOCUMENTS_ADVISERS_COMPLETED';

export const DOWNLOAD_DOCUMENT_ADVISERS_REQUESTED =
  'DOWNLOAD_DOCUMENT_ADVISERS_REQUESTED';
export const DOWNLOAD_DOCUMENT_ADVISERS_COMPLETED =
  'DOWNLOAD_DOCUMENT_ADVISERS_COMPLETED';
export const DOWNLOAD_DOCUMENT_ADVISERS_FAILED =
  'DOWNLOAD_DOCUMENT_ADVISERS_FAILED';

export const VIEW_DOCUMENT_ADVISERS_REQUESTED =
  'VIEW_DOCUMENT_ADVISERS_REQUESTED';
export const VIEW_DOCUMENT_ADVISERS_COMPLETED =
  'VIEW_DOCUMENT_ADVISERS_COMPLETED';
export const VIEW_DOCUMENT_ADVISERS_FAILED = 'VIEW_DOCUMENT_ADVISERS_FAILED';

export const RESET_VIEW_DOCUMENT_ADVISERS_REQUESTED =
  'RESET_VIEW_DOCUMENT_ADVISERS_REQUESTED';
export const RESET_VIEW_DOCUMENT_ADVISERS_COMPLETED =
  'RESET_VIEW_DOCUMENT_ADVISERS_COMPLETED';
export const RESET_VIEW_DOCUMENT_ADVISERS_FAILED =
  'RESET_VIEW_DOCUMENT_ADVISERS_FAILED';
